import React from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { observer } from "mobx-react";
import { Grid, Header, Card } from "semantic-ui-react";
import MediaItem from "~/models/Media/MediaItem";
import FlyerMediaItem from "./FlyerMediaItem";

const FlyerTemplate = observer(({ photoSlots, onDragEnd, t, useTranslation }) => {
  const [firstMediaItem, ...remainingMediaItems] = photoSlots;

  return (
    <Grid className="flyer-template">
      <Grid.Row className="flyer-template-primary-wrap">
        <Grid.Column>
          <Header>{useTranslation ? t("clientPanelMisc:flyerTemplate") : "Flyer Template"}</Header>
          <Card.Group centered itemsPerRow={3}>
            {[firstMediaItem].map(mediaItem => (
              <FlyerMediaItem
                key={mediaItem.mediaItemId}
                mediaItem={mediaItem}
                source="template"
                centered
                onDragEnd={onDragEnd}
              />
            ))}
          </Card.Group>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row className="flyer-template-secondary-wrap">
        <Grid.Column>
          <Card.Group itemsPerRow={6}>
            {remainingMediaItems.map(mediaItem => (
              <FlyerMediaItem
                key={mediaItem.mediaItemId}
                mediaItem={mediaItem}
                source="template"
                onDragEnd={onDragEnd}
              />
            ))}
          </Card.Group>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
});

FlyerTemplate.propTypes = {
  photoSlots: PropTypes.arrayOf(PropTypes.instanceOf(MediaItem)).isRequired,
  onDragEnd: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  // @todo Remove when we will find another solution for the translation at the provider panel
  useTranslation: PropTypes.bool,
};

FlyerTemplate.defaultProps = {
  useTranslation: false,
};

export default withTranslation()(FlyerTemplate);
